import React, {useState} from 'react';
import useEventListener from 'hooks/useEventListener';
import {t} from 'lib/i18n';

interface IDragEditorSize {
  isChat?: boolean;
}

/**
 * 영상/편집 영역 리사이즈 컴포넌트
 * http://res.afreecatv.com/script/webeditor.js UI 스크립트 참조
 */

const DragEditorSize = ({isChat}: IDragEditorSize) => {
  const [resize, setResize] = useState({
    isResize: false,
    positionY: 0,
    startWidth: 0,
  });

  // MOUSE UP일 때 초기화
  const handleMouseUp = () => {
    setResize({
      ...resize,
      isResize: false,
    });
  };

  // 움직일 때 max-width값 셋팅
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // e.preventDefault(); // 다른 드래그 영역 선택 안되도록 하기 위해(document로 잡고있어서 텍스트박스 입력도 안되서 제외함)

    const topHeight =
      resize.startWidth + (Number(e.clientY) - resize.positionY); // 마우스 이동값

    if (!resize.isResize) return;

    if (topHeight <= 460 + 298 || topHeight >= 1200) return;
    // height 제한
    else {
      const resizing_area = document.querySelector(
        '.webeditor_player_contents',
      ) as HTMLDivElement;

      const newWidth = isChat
        ? Math.max(topHeight, 796)
        : Math.max(topHeight, 500);

      resizing_area.setAttribute('style', `max-width: ${newWidth}px;`);
    }
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // e.preventDefault(); // 다른 드래그 영역 선택 안되도록 하기 위해(document 잡고있어서 텍스트박스 입력도 안되서 제외함)

    const target = e.target as Element;
    // 드래그 영역 눌렀을 때만 아래 로직 태우게 해야함
    // document로 잡았기 때문에 플레이어 영역 드래그까지 같이 포함되고 있음
    if (target.className !== 'dragResize') return;

    const resizing_area = document.querySelector(
      '.webeditor_player_contents',
    ) as HTMLDivElement;
    if (!resizing_area) return;
    if (!resizing_area.style.maxWidth) return;

    setResize({
      isResize: true,
      positionY: e.clientY,
      startWidth: parseInt(resizing_area.style.maxWidth),
    });
  };

  // 원할한 화면 drag 위해 document에 이벤트 활성화
  useEventListener('mousedown', handleMouseDown);
  useEventListener('mouseup', handleMouseUp);
  useEventListener('mouseleave', handleMouseUp);
  useEventListener('mousemove', handleMouseMove);

  return (
    // @ts-expect-error tip is not a valid prop
    // eslint-disable-next-line react/no-unknown-property
    <div id='drag' className='dragResize' tip={t('크기조정')}>
      <span className='dragResize'>{t('영상영역 리사이즈')}</span>
    </div>
  );
};

export default DragEditorSize;
